import { createContext } from 'react';
import CmsGlobalElementsService from '../Services/CmsGlobalElementsService';

const CmsGlobalElementsContext = createContext<CmsGlobalElementsService>(
  new CmsGlobalElementsService()
);

export default CmsGlobalElementsContext;
